module.exports = __webpack_public_path__ + "startpage-746fed5a/background-3dc4b04830ff7cf6945938d9c6ad8d63.svg";